import assign from 'object-assign';
import { EventEmitter } from 'events';

import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';

const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'ORDERS_CHANGED';

const createOrderState = {
  order: null,
  created: false,
  pending: false,
  error: null,
};

const OrderCreateStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  onCreateOrderFail(message) {
    createOrderState.pending = false;
    createOrderState.order = null;
    createOrderState.error = message;
    this.emitChange();
  },
  onCreateOrderSuccess(payload) {
    createOrderState.order = payload;
    createOrderState.error = null;
    createOrderState.pending = false;
    this.emitChange();
  },
  onCreateOrderRequested() {
    createOrderState.pending = true;
    createOrderState.error = null;
    createOrderState.order = null;
    this.emitChange();
  },
  getCreateOrderState() {
    return createOrderState;
  },
});

OrderCreateStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
  const action = payload.action;
  switch (action.type) {
    case ActionTypes.CREATE_ORDER_REQUEST:
    case ActionTypes.CREATE_ORDER_AND_TEMPLATE_REQUEST:
      OrderCreateStore.onCreateOrderRequested();
      break;
    case ActionTypes.CREATE_ORDER_AND_TEMPLATE_SUCCESS:
    case ActionTypes.SAVE_TEMPLATE_AND_BOOK_ORDER_SUCCESS:
    case ActionTypes.CREATE_ORDER_SUCCESS:
      OrderCreateStore.onCreateOrderSuccess(action.order);
      break;
    case ActionTypes.CREATE_ORDER_FAIL:
      OrderCreateStore.onCreateOrderFail(action.error);
      break;
    default:
      break;
  }
});

export default OrderCreateStore;
